import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Product } from "../../../domain/entities/product/Product";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

const useGetProductDetails = (variantId: string, isRecommended: boolean) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const {
    isLoading,
    data: productDetail,
    refetch,
  } = useQuery(
    {
      queryKey: ["productDetail", variantId, auth],
      queryFn: async () => {
        return await productRepo.getProductDetails(variantId, isRecommended, auth, apiUrl);
      },
      enabled: Boolean(auth) && Boolean(variantId),
    },
    queryClient,
  );

  return {
    isLoading,
    productDetails: productDetail || ({} as Product),
    refetchProductDetail: refetch,
  };
};

export { useGetProductDetails };
